import React from 'react'
import { Login, LoginLayout } from 'ui-classic-common-library'

import pkg from '../../../package.json'

interface LoginPageProps {
  isLoadingSession: boolean
}

export const LoginPage = ({ isLoadingSession }: LoginPageProps) => {
  return (
    <LoginLayout footerVersion={pkg.version} includeHeader={false}>
      <Login
        onLoginSuccess={() => {
          window.location.href = '/'
        }}
        isLoadingSession={isLoadingSession}
        allowLegacyLogin
      />
    </LoginLayout>
  )
}
